import type * as Notifications from 'expo-notifications';

export function useLastNotificationResponseSafe():
  | Notifications.NotificationResponse
  | null
  | undefined {
  return null;
}
